<style scoped>
.v-application .text-h3 {
  font-family: "Prompt", sans-serif !important;
  font-size: 32px !important;
  text-align: center;
}
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 18px !important;
  /* font-weight: bold; */
  text-align: center;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
.p1 {
  text-align: justify;
  font-size: 16px;
  margin-top: -20px;
}
.p1:before {
  content: "\2713";
  font-size: 24px;
  color: green;
}
</style>

<template>
  <div>
    <menuBar></menuBar>
    <v-container v-if="this.$AppName.name == 'นิวโชคอำนวยเชียงใหม่'">
      <v-row justify="center">
        <v-col cols="12" lg="12">
          <div class="text-h3 font-weight-black text-spacing" color="blue">
            เกี่ยวกับเรา
            <!-- <span class="primary--text"> {{this.$AppName.CoLtdMenuBar}} </span> -->
            <span class="primary--text">นิวโชคอำนวยเชียงใหม่</span>
          </div>
        </v-col>
        <v-col cols="12" lg="12">
          <div class="text-h4">
            {{ this.$AppName.CoLtdMenuBarFull }}
            รับเก็บขนและกำจัดขยะติดเชื้อในสถานพยาบาล เขตจังหวัดเชียงใหม่ ลำพน
            ลำปาง
            มีประสบการณ์การเก็บขนและกำจัดขยะมูลฝอยติดเชื้อและได้รับความไว้วางใจจากโรงพยาบาลเอกชนในจังหวัดเชียงใหม่
            เช่น โรงพยาบาลลานนา โรงพยาบาลเชียงใหม่-ราม
            โรงพยาบาลกรุงเทพ-เชียงใหม่ เป็นต้น รวมทั้งคลินิกทันตกรรม
            คลินิกเสริมความงาม ฯลฯ รวมประมาณ 500 แห่ง
            และได้รับใบอนุญาติการเก็บขนและกำจัดมูลฝอยติดเชื้อจากหน่วยราชการท้องถิ่นเทศบาลนครเชียงใหม่พร้อมทั้งทีมงานได้รับการฝึกอบรมการป้องกันและระงับการแพร่เชื้อหรืออันตรายที่อาจเกิดจากมูลฝอยติดเชื้อ
            ตามประกาศกระทรวงสาธารณสุข จัดโดย กรมอนามัย กระทรวงสาธารณสุข
          </div>
        </v-col>
        <v-col cols="12" lg="12" class="mt-10">
          <div class="text-h3 font-weight-black text-spacing" color="blue">
            <span class="primary--text">
              สถานพยาบาลจะได้รับ การบริการเก็บ ขนมูลฝอยติดเชื้อ
            </span>
          </div>
        </v-col>
        <v-col cols="12" lg="5">
          <div class="text-h4">
            <p class="p1">
              ผู้ใช้บริการเก็บ ขน มูลฝอยติดเชื้อ จะได้รับสัญญาการเก็บ ขน
              มูลฝอยติดเชื้อเพื่อเป็นหลักประกันในการให้บริการเก็บ
              ปฏิบัติงานการเก็บ ขนมูลฝอยติดเชื้อตามข้อตกลงในสัญญาอย่างเคร่งครัด
            </p>
            <p class="p1">
              ผู้ใช้บริการเก็บ ขน มูลฝอยติดเชื้อ
              จะได้รับการบริการการศึกษาดูงานโครงการตามรอยการ เก็บ ขนมูลฝอย
              ติดเชื้อ ของ {{ this.$AppName.CoLtdMenuBarFull }}
              จากแหล่งกำเนิด(โรงพยาบาล)ถึงแหล่งกำจัด(เตาเผา) บ. โชติฐกรณ์
              พิบูลย์จำกัด จ.นครสวรรค์
            </p>
            <p class="p1">
              ผู้ใช้บริการเก็บ ขน มูลฝอยติดเชื้อ จะได้รับความถี่ในการเข้าเก็บ ขน
              มูลฝอยติดเชื้ออย่างน้อยสัปดาห์ละ 2
              ครั้งหรือมากกว่าในกรณีมีมูลฝอยติดเชื้อมากเป็นพิเศษ
            </p>
            <p class="p1">
              ผู้ใช้บริการเก็บ ขน มูลฝอยติดเชื้อ
              จะได้รับบริการตรงตามมาตรฐานที่กระทรวงสาธารณสุขกำหนดพร้อมทั้ง
              การประเมินการปฏิบัติงานของเจ้าหน้าที่อย่างสม่ำเสมอ
            </p>
            <p class="p1">
              ผู้ใช้บริการเก็บ ขน มูลฝอยติดเชื้อ
              จะได้รับการบริการด้วยความเป็นมิตรและสุภาพเรียบร้อยจากเจ้าหน้าที่
              เก็บ ขน มูลฝอยติดเชื้อ ของ {{ this.$AppName.CoLtdMenuBarFull }}
            </p>
            <p class="p1">
              ผู้ใช้บริการเก็บ ขน มูลฝอยติดเชื้อ จะได้รับบริการการแก้ไข
              ปรับปรุงในด้านการบริการอย่างรวดเร็วและทัน ต่อเหตุการณ์
              ในกรณีมีข้อแนะนำและข้อท้วงติงจากสถานพยาบาล
            </p>
          </div>
        </v-col>
        <v-col cols="12" lg="7">
          <v-img src="@/assets/index_pic1.png"></v-img>
        </v-col>
        <v-col cols="12" lg="12" class="mt-10">
          <div class="text-h3 font-weight-black text-spacing" color="blue">
            <span class="primary--text"> สถานพยาบาลจะมั่นใจได้อย่างไร </span>
          </div>
        </v-col>
        <v-col cols="12" lg="6">
          <v-img src="@/assets/index_pic2.png"></v-img>
        </v-col>
        <v-col cols="12" lg="6">
          <v-img src="@/assets/index_pic3.png"></v-img>
        </v-col>

        <v-col cols="12" lg="6">
          <v-img src="@/assets/index_pic4.png"></v-img>
        </v-col>
        <v-col cols="12" lg="6">
          <v-img src="@/assets/index_pic5.png"></v-img>
        </v-col>

        <v-col cols="12" lg="6">
          <v-img src="@/assets/index_pic6.png"></v-img>
        </v-col>
        <v-col cols="12" lg="6">
          <v-img src="@/assets/index_pic7.png"></v-img>
        </v-col>

        <v-col cols="12" lg="6"> </v-col>
        <v-col cols="12" lg="6"> </v-col>
      </v-row>
    </v-container>
    <v-footer
      color="light-blue darken-2"
      padless
      v-if="this.$AppName.name == 'นิวโชคอำนวยเชียงใหม่'"
    >
      <v-container>
        <v-row justify="center">
          <v-col cols="12" lg="4">
            <h2 style="color: white">ADDRESS</h2>
            <v-divider dark class="my-3"></v-divider>
            <p style="color: white">
              <v-icon dark> mdi-home </v-icon>
              389/40 หมู่ 2 โครงการ พรสวรรค์ พลาซ่า, ตำบล สันผีเสื้อ
              อำเภอเมืองเชียงใหม่ จังหวัดเชียงใหม่ 50300
            </p>
          </v-col>
          <v-col cols="12" lg="4">
            <h2 style="color: white">ABOUT</h2>
            <v-divider dark class="my-3"></v-divider>
            <p style="color: white">
              {{ this.$AppName.limited_company }}
              รับเก็บขนและกำจัดขยะติดเชื้อในสถานพยาบาล เขตจังหวัดเชียงใหม่ ลำพน
              ลำปาง
              มีประสบการณ์การเก็บขนและกำจัดขยะมูลฝอยติดเชื้อและได้รับความไว้วางใจจากโรงพยาบาลเอกชนในจังหวัดเชียงใหม่
            </p>
          </v-col>
          <v-col cols="12" lg="4">
            <h2 style="color: white">CONTACT</h2>
            <v-divider dark class="my-3"></v-divider>
            <span style="color: white"
              ><v-img
                src="@/assets/icons8-line-50.png"
                width="25px"
                height="25px"
                style="display: inline-flex"
              ></v-img>
              Line id : @new_cm </span
            ><br />
            <span style="color: white">
              <v-icon dark> mdi-email </v-icon
              >chokumnuaichiangmai@gmail.com </span
            ><br />
            <span style="color: white">
              <v-icon dark> mdi-phone </v-icon>081-5959004,081-6949845 </span
            ><br />

            <span style="color: white">
              <v-icon dark> mdi-facebook </v-icon>
              รับจัดเก็บมูลฝอยติดเชื้อ {{ this.$AppName.limited_company }}
            </span>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
    <v-container v-if="this.$AppName.name == 'เทศบาลนครเชียงใหม่'">
      <v-row justify="center">
        <v-col cols="12" lg="12">
          <div class="text-h3 font-weight-black text-spacing" color="blue">
            เกี่ยวกับเรา
            <span class="primary--text">เทศบาลนครเชียงใหม่</span>
          </div>
        </v-col>
        <v-col cols="12" lg="12">
          <div class="text-h4" justify="left">
            เทศบาลนครเชียงใหม่ เดิมเป็นสุขาภิบาลเมืองเชียงใหม่ ตั้งแต่ปี พ.ศ.
            ๒๔๕๘ ขึ้นตรงต่อมณฑลพายัพต่อมาเมื่อมีการปกครองในระบอบประชาธิปไตย
            ในปีพ.ศ. ๒๔๗๕
            สภาผู้แทนราษฎรจึงมีมติสมควรจัดตั้งชุมชนซึ่งส่วนใหญ่เป็นสุขาภิบาลให้มีฐานะเป็น
            เทศบาล
            เทศบาลนครเชียงใหม่ได้รับฐานะจากสุขาภิบาลเมืองเชียงใหม่ขึ้นเป็น
            “เทศบาลนครเชียงใหม่” ในปี พ.ศ. ๒๔๗๘ ประกาศในราชกิจจา นุเบกษา เล่มที่
            ๕๒ ตอนที่ ๘๐ ลงวันที่ ๒๙ มีนาคม ๒๔๗๘ มีพื้นที่รับผิดชอบ ๑๗.๕๐
            ตารางกิโลเมตร มีอำนาจหน้าที่ตามบทบัญญัติในพระราชบัญญัติจัด
            ระเบียบเทศบาล พ.ศ.๒๔๗๖ ทุกประการนับเป็นเทศบาลนครแห่งแรกในประเทศไทย
            ต่อมาเทศบาลนครเชียงใหม่มีความเจริญของตัวเมืองมากขึ้น มีชุมชนหนาแน่น
            และ ขยายตัวโดยรอบ ในปี พ.ศ. ๒๕๒๖ จึงได้มีพระราช
            กฤษฎีกาขยายเขตเทศบาลนครเชียงใหม่ จังหวัดเชียงใหม่ พ.ศ. ๒๕๒๖
            มีพื้นที่รับผิดชอบ ๔๐.๒๑๖ ตารางกิโลเมตร ประกาศในราชกิจจานุเบกษา ฉบับ
            พิเศษเล่มที่ ๑๐๐ ตอนที่ ๕๓ ลงวันที่ ๕ เมษายน ๒๕๒๖ ครอบคลุมพื้นที่ ๑๔
            ตำบล ได้แก่ ตำบลหายยา ตำบลช้างม่อย ตำบลศรีภูมิ ตำบลวัดเกต
            ตำบลช้างคลาน ตำบลพระสิงห์ ตำบลสุเทพบางส่วน ตำบลป่าแดดบางส่วน
            ตำบลฟ้าฮ่าม ตำบลหนองป่าคลั่งบางส่วน ตำบลท่าศาลาบางส่วน ตำบลป่าตัน
            ตำบลหนองหอยบางส่วน และตำบลช้างเผือกบางส่วน
            และนอกจากที่กล่าวมาข้างต้นนี้แล้ว
            เทศบาลนครเชียงใหม่ยังมีหน้าที่และความรับผิดชอบครอบคลุม แขวงอีก ๔
            แขวง ได้แก่ แขวงนครพิงค์ แขวงกาวิละ แขวงเม็งรายและแขวงศรีวิชัย 
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import menuBar from "../components/menuBar";

export default {
  name: "Index",
  components: {
    menuBar,
  },
  data: () => ({
    tab: null,
    links: ["ADDRESS", "ABOUT", "CONTACT"],
  }),
};
</script>
